(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arv-header-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(section) {
    if (!section || section.dataset.arvReady === 'true') return;
    section.dataset.arvReady = 'true';
    const slides = [...section.querySelectorAll('[data-arv-slide]')];
    const dots = [...section.querySelectorAll('[data-arv-dot]')];
    const current = section.querySelector('[data-arv-current]');
    const announcement = section.querySelector('[data-arv-announcement]');
    const pause = section.querySelector('[data-arv-pause]');
    const pauseIcon = section.querySelector('[data-arv-pause-icon]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, userPaused = false, hoverPaused = false, focusPaused = false, draggingX = null;
    function stop() { clearTimeout(timer); timer = null; section.classList.remove('is-playing'); }
    function canPlay() { return !userPaused && !hoverPaused && !focusPaused && !reduceMotion.matches && !document.hidden; }
    function schedule() { stop(); if (!canPlay()) return; section.classList.add('is-playing'); timer = setTimeout(() => show((index + 1) % slides.length, false), Number(section.dataset.interval) || 6500); }
    function show(next, manual) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { const active = i === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      current.textContent = String(index + 1).padStart(2, '0');
      if (manual) announcement.textContent = dots[index].getAttribute('aria-label') || '';
      schedule();
    }
    section.querySelector('[data-arv-prev]').addEventListener('click', () => show(index - 1, true));
    section.querySelector('[data-arv-next]').addEventListener('click', () => show(index + 1, true));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true)));
    pause.addEventListener('click', () => { userPaused = !userPaused; pause.setAttribute('aria-pressed', String(userPaused)); pause.setAttribute('aria-label', userPaused ? (document.documentElement.lang === 'ar' ? 'تشغيل الحركة التلقائية' : 'Reprendre le défilement automatique') : (document.documentElement.lang === 'ar' ? 'إيقاف الحركة التلقائية' : 'Mettre le défilement en pause')); pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ'; schedule(); });
    section.addEventListener('mouseenter', () => { hoverPaused = true; stop(); });
    section.addEventListener('mouseleave', () => { hoverPaused = false; schedule(); });
    section.addEventListener('focusin', () => { focusPaused = true; stop(); });
    section.addEventListener('focusout', () => { focusPaused = section.contains(document.activeElement); if (!focusPaused) schedule(); });
    section.addEventListener('touchstart', event => { draggingX = event.touches[0]?.clientX ?? null; }, {passive:true});
    section.addEventListener('touchend', event => { if (draggingX === null) return; const end = event.changedTouches[0]?.clientX ?? draggingX; const delta = end - draggingX; draggingX = null; if (Math.abs(delta) > 45) show(index + ((document.documentElement.dir === 'rtl' ? delta > 0 : delta < 0) ? 1 : -1), true); }, {passive:true});
    document.addEventListener('visibilitychange', schedule);
    reduceMotion.addEventListener('change', schedule);
    schedule();
  }
  function initAll(root) { root.querySelectorAll('[data-arv-slider]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arv-home-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(section) {
    if (!section || section.dataset.arvReady === 'true') return;
    section.dataset.arvReady = 'true';
    const slides = [...section.querySelectorAll('[data-arv-slide]')];
    const dots = [...section.querySelectorAll('[data-arv-dot]')];
    const current = section.querySelector('[data-arv-current]');
    const announcement = section.querySelector('[data-arv-announcement]');
    const pause = section.querySelector('[data-arv-pause]');
    const pauseIcon = section.querySelector('[data-arv-pause-icon]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer, userPaused = false, hoverPaused = false, focusPaused = false, draggingX = null;
    function stop() { clearTimeout(timer); timer = null; section.classList.remove('is-playing'); }
    function canPlay() { return !userPaused && !hoverPaused && !focusPaused && !reduceMotion.matches && !document.hidden; }
    function schedule() { stop(); if (!canPlay()) return; section.classList.add('is-playing'); timer = setTimeout(() => show((index + 1) % slides.length, false), Number(section.dataset.interval) || 6500); }
    function show(next, manual) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { const active = i === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      current.textContent = String(index + 1).padStart(2, '0');
      if (manual) announcement.textContent = dots[index].getAttribute('aria-label') || '';
      schedule();
    }
    section.querySelector('[data-arv-prev]').addEventListener('click', () => show(index - 1, true));
    section.querySelector('[data-arv-next]').addEventListener('click', () => show(index + 1, true));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true)));
    pause.addEventListener('click', () => { userPaused = !userPaused; pause.setAttribute('aria-pressed', String(userPaused)); pause.setAttribute('aria-label', userPaused ? (document.documentElement.lang === 'ar' ? 'تشغيل الحركة التلقائية' : 'Reprendre le défilement automatique') : (document.documentElement.lang === 'ar' ? 'إيقاف الحركة التلقائية' : 'Mettre le défilement en pause')); pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ'; schedule(); });
    section.addEventListener('mouseenter', () => { hoverPaused = true; stop(); });
    section.addEventListener('mouseleave', () => { hoverPaused = false; schedule(); });
    section.addEventListener('focusin', () => { focusPaused = true; stop(); });
    section.addEventListener('focusout', () => { focusPaused = section.contains(document.activeElement); if (!focusPaused) schedule(); });
    section.addEventListener('touchstart', event => { draggingX = event.touches[0]?.clientX ?? null; }, {passive:true});
    section.addEventListener('touchend', event => { if (draggingX === null) return; const end = event.changedTouches[0]?.clientX ?? draggingX; const delta = end - draggingX; draggingX = null; if (Math.abs(delta) > 45) show(index + ((document.documentElement.dir === 'rtl' ? delta > 0 : delta < 0) ? 1 : -1), true); }, {passive:true});
    document.addEventListener('visibilitychange', schedule);
    reduceMotion.addEventListener('change', schedule);
    schedule();
  }
  function initAll(root) { root.querySelectorAll('[data-arv-slider]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.gzArticleTocRegistered) return;
    window.gzArticleTocRegistered = true;
    const initialize = (scope = document) => {
      const sections = scope.matches?.('[data-gz-article]') ? [scope] : scope.querySelectorAll('[data-gz-article]');
      sections.forEach((section) => {
        const toc = section.querySelector('[data-gz-toc]');
        const list = section.querySelector('[data-gz-toc-list]');
        const body = section.querySelector('[data-gz-article-body]');
        if (!toc || !list || !body || toc.dataset.ready === 'true') return;
        const headings = body.querySelectorAll('h2');
        if (headings.length < 2) return;
        const fragment = document.createDocumentFragment();
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${section.id}-heading-${index + 1}`;
            while (document.getElementById(id)) id += '-next';
            heading.id = id;
          }
          heading.tabIndex = -1;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          fragment.append(item);
        });
        list.replaceChildren(fragment);
        toc.dataset.ready = 'true';
        toc.hidden = false;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-header"]) return;
  try {
    
  document.addEventListener('click',event=>{document.querySelectorAll('.gz-nav-details[open],.gz-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open')})});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.gz-nav-details[open],.gz-mobile-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeEasySellStyle = () => {
      const productRoot = document.querySelector('[data-gz-product]');
      if (!productRoot || productRoot.dataset.gzAppStyleReady) return;
      productRoot.dataset.gzAppStyleReady = 'true';
      const applyProperties = (element, properties) => {
        if (!element) return;
        for (const [property, value] of Object.entries(properties)) {
          const normalized = document.createElement('span').style;
          normalized.setProperty(property, value, 'important');
          if (element.style.getPropertyValue(property) !== normalized.getPropertyValue(property) || element.style.getPropertyPriority(property) !== 'important') element.style.setProperty(property, value, 'important');
        }
        element.dataset.gzStyled = 'true';
      };
      const update = () => {
        if (!productRoot.isConnected) { observer.disconnect(); return; }
        applyProperties(productRoot.querySelector('#es-form-container'), { 'color': 'var(--gz-ink)', 'font-size': '16px', 'border-color': 'var(--gz-line)', 'border-radius': '16px', 'box-shadow': '0 6px 22px #122c3b0a' });
        for (const button of document.querySelectorAll('#es-form-button, #es-sticky')) {
          applyProperties(button, { 'background': 'var(--gz-green)', 'color': '#fff', 'font-size': '16px', 'border-color': 'var(--gz-green)', 'border-radius': '10px', 'box-shadow': 'none' });
        }
        const sticky = document.querySelector('#es-sticky');
        if (sticky && productRoot.dataset.gzCodCta) {
          const walker = document.createTreeWalker(sticky, NodeFilter.SHOW_TEXT);
          let textNode;
          while ((textNode = walker.nextNode())) {
            if (textNode.nodeValue.includes('COMMANDEZ MAINTENANT')) textNode.nodeValue = textNode.nodeValue.replaceAll('COMMANDEZ MAINTENANT', productRoot.dataset.gzCodCta);
          }
        }
      };
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; update(); });
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
      update();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeEasySellStyle, { once: true });
    else initializeEasySellStyle();
    document.addEventListener('shopify:section:load', initializeEasySellStyle);
  })();
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-gz-variant]');
    if (!select) return;
    const root = select.closest('[data-gz-product]');
    const option = select.selectedOptions[0];
    const button = root.querySelector('[data-gz-add]');
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
    root.querySelector('[data-gz-availability]').textContent = available ? button.dataset.stockLabel : button.dataset.unavailableLabel;
    root.querySelector('[data-gz-price]').textContent = option.dataset.price;
    const compare = root.querySelector('[data-gz-compare]');
    compare.hidden = !option.dataset.compare;
    compare.textContent = option.dataset.compare || '';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(Debutify.settings.dbtfy_sticky_header == false) return;

      this.defaultColorScheme = "dbtfy-color-"+this.dataset.colorScheme;
      this.defaultCustomColorScheme = "color-"+this.dataset.customColorScheme;
      this.transparentColorScheme = "dbtfy-color-"+this.dataset.transparentHeaderColorScheme;
      this.transparentCustomColorScheme = "color-"+this.dataset.customTransparentHeaderColorScheme;
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
        this.classList.add('dbtfy-header--transparent');
        this.classList.add(this.transparentColorScheme);
        this.classList.add(this.transparentCustomColorScheme);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        
        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.defaultColorScheme,this.defaultCustomColorScheme);
          if(this.classList.contains("dbtfy-header--transparent")){
            this.classList.remove('dbtfy-header--transparent');
          }
          if(this.transparentColorScheme){
            this.classList.remove(this.transparentColorScheme);
          }
          if (this.transparentCustomColorScheme) {
            this.classList.remove(this.transparentCustomColorScheme);
          }
        }
        
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {

        if(Debutify.widgets.header.header_transparent && document.body.classList.contains('template-index')){
          this.classList.add(this.transparentColorScheme,this.transparentCustomColorScheme,'dbtfy-header--transparent');
          if(this.defaultColorScheme){
            this.classList.remove(this.defaultColorScheme);
          }
          if (this.defaultCustomColorScheme) {
            this.classList.remove(this.defaultCustomColorScheme);
          }
        }

        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
